// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cmXaS","clinicsSelect":"styles_clinicsSelect__HJBSg"};